import { Component, Element, Host, h, Prop } from "@stencil/core";
import { track } from "../../utils/tracking";

/**
 * @slot headline - Slot for the headline (`<h1>`)
 * @slot text - Slot for the description text (`<p>` or `<div>`)
 * @slot image - Slot for the header image (`<picture>` with 3:2 aspect ratio for mobile and 3:1 for desktop)
 * @slot zoom-image - Slot for the zoomed image (`<picture>` with 3:2 aspect ratio for mobile and 3:1 for desktop)
 */
@Component({
    tag: "ux-iws-nb-product-header",
    styleUrl: "nb-product-header.scss",
    shadow: false,
})
export class NbProductHeader {
    private baseClass = "ux-iws-nb-product-header";

    /**
     * The element reference for the component.
     * Used to access the DOM and manipulate styles or classes.
     */
    @Element() element: HTMLUxIwsNbProductHeaderElement;

    /**
     * The label for the zoom in button.
     * @default "Zoom in"
     * @deprecated Zooming functionality has been removed
     */
    @Prop() zoomInLabel = "Zoom in";

    /**
     * The label for the zoom out button.
     * @default "Zoom out"
     * @deprecated Zooming functionality has been removed
     */
    @Prop() zoomOutLabel = "Zoom out";

    componentDidLoad() {
        this.element
            .querySelector(`[data-trigger-async-modal]`)
            ?.addEventListener("click", () => {
                track("click_product_header_contact_modal", {});
            });
    }

    render() {
        return (
            <Host class={this.baseClass}>
                <div class={`${this.baseClass}__image`}>
                    <slot name="image" />
                </div>
                <header class={`${this.baseClass}__header`}>
                    <div class={`${this.baseClass}__box`}>
                        <div class={`${this.baseClass}__text`}>
                            <slot name="headline" />
                            <slot name="text" />
                        </div>
                        <div class={`${this.baseClass}__cta`}>
                            <slot name="cta" />
                        </div>
                    </div>
                </header>
            </Host>
        );
    }
}
